import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React, { useState, useEffect } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";

import BulkUpdatePopUp from "../MobilizationData/BulkUpdatePopUp/BulkUpdatePopUp";
import MobilizationFormPopUp from "../MobilizationData/MobilizationFormPopUp";
import { useDispatch } from "react-redux";
import { FaFilter } from "react-icons/fa";
import EmployeeFilter from "../MobilizationData/filterPopUp";
import RemobilizationFormPopUp from "./RemobilizationFormPopup";
import Idle_PopUp from "./Idle_PopUp";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";

export default function RemobilizationList({
  titles = [],
  list = [],
  trigger,
  setTrigger,
}) {
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = React.useState({});

  const [checked, setChecked] = React.useState([]);

  const dispatch = useDispatch();

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const [listData, SetListData] = useState([]);
  const [selectedData, setSelectedData] = useState();
  const [triggerState, setTriggerState] = useState(true);

  const [IdlePopUp, setIdlePopUp] = useState(false);

  const handleCheckboxChange = (event, employee_id, list, isPrimary) => {
    if (isPrimary === "global") {
      if (checkedItems.candidate_id === employee_id) {
        setCheckedItems({});
        return;
      }
      setCheckedItems(list);

      const filteredChecked = checked?.filter(
        (item) => item.candidate_id === employee_id
      );
      if (filteredChecked?.length > 0) {
        setChecked(filteredChecked);
        return;
      }
      setChecked([]);
    }

    // if (isPrimary === "local") {
    //   // If no filtered results, add the new `list`
    //   setChecked((prev) => [...prev, list]);
    // }
    if (isPrimary === "local") {
      setChecked((prev) => {
        const isAlreadyChecked = prev?.some(
          (item) => item.candidate_id === list.candidate_id
        );

        if (isAlreadyChecked) {
          // If the employee exists, filter them out
          return prev.filter((item) => item.candidate_id !== list.candidate_id);
        } else {
          // If the employee doesn't exist, add them to the array
          return [...prev, list];
        }
      });
    }
  };

  const [popUp, setPopUp] = useState(false);
  const [clientPopUp, setClientPopUp] = useState(false);

  // const handlePopUp = () => {
  //   const checkedEntries = Object.entries(checked);
  //   const checkedItemsEntries = Object.entries(checkedItems);
  //   if (!triggerState) {
  //     dispatch(
  //       setAppError({
  //         msg: "Employees from mutipile projects cannot be selected.",
  //       })
  //     );
  //     return;
  //   }

  //   if (checkedEntries.length !== 0 && checkedItemsEntries.length !== 0) {
  //     setPopUp(true);
  //   } else if (checkedEntries.length !== 0) {
  //     setIdlePopUp(true);
  //   } else {
  //     dispatch(
  //       setAppError({
  //         msg: "Please select Check box",
  //       })
  //     );
  //   }
  // };

  const handlePopUp = () => {
    if (checkedItems.candidate_id) {
      const filtered = checked.every(
        (item) => item.candidate_id === checkedItems.candidate_id
      );
      if (filtered) {
        setPopUp(true);
        return;
      } else {
        dispatch(
          setAppError({
            msg: "Client change cannot happen on bulk selection.",
          })
        );
        return;
      }
    } else {
      const firstProjectId = checked[0]?.project_id; // Get the project_id of the first employee

      const allSameProject = checked.every(
        (item) => item.project_id === firstProjectId
      );
      if (allSameProject) {
        setIdlePopUp(true);
      } else {
        dispatch(
          setAppError({
            msg: "Employees from different projects cannot be selected.",
          })
        );
        return;
      }
    }
  };
  // useEffect(() => {
  //   const firstProjectId =
  //     listData?.length > 0 ? listData && listData[0]?.project_id : [];
  //   console.log("firstProjectId.........", firstProjectId);
  //   for (const item of listData) {
  //     if (item.project_id !== firstProjectId) {
  //       setTriggerState(false);
  //       break;
  //     } else {
  //       setTriggerState(true);
  //     }
  //   }
  //   setSelectedData(firstProjectId);
  // }, [listData, selectedProject]);

  const [downloadLoading, setDownloadLoading] = useState(false);

  const token = localStorage.getItem("nodeToken");

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/demobilization/idleCandidates/download/${"REMOBILIZE"}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Re_Mobilization summary`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  return (
    <>
      <div className="pt-2 uppercase">
        <div className="flex justify-between space-x-2">
          <div className="flex gap-2 items-center">
            <Search
              searchKey={["candidate_id", "point_of_hire", "name", "client"]}
              setSearchWords={setSearchWords}
            />
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray-500 text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() => {
                downloadFile();
              }}
            >
              <p>Download</p>
            </button>
          </div>
          <div className="flex gap-2 items-center">
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              // disabled={isMobilizationButtonDisabled()}
              onClick={() => {
                handlePopUp();
              }}
            >
              <p>Remobilize</p>
            </button>
            <button
            // onClick={() => {
            //   onFilterClick();
            // }}
            >
              <FaFilter />
            </button>
          </div>
        </div>

        <CountPerPage />
        <div
          className="overflow-x-auto m-2"
          style={{ backgroundColor: "white" }}
        >
          <table className="min-w-full divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                {titles.map((columnName, index) => (
                  <th
                    key={index}
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                  >
                    {columnName}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-gray-10">
              {!list?.isLoading &&
                currentList?.map((listItem, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.point_of_hire}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.candidate_id}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.nationality}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.actual_profession}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.visa_profession}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.total_salary}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem?.client}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.visa_provider
                        ? listItem.visa_provider
                        : listItem.Overseas_visa_provider}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.iqama_number}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.iqama_expiry_date_g}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.arrival_date
                        ? new Date(listItem.arrival_date)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .split(" ")
                            .join("-")
                            .toUpperCase()
                        : "-----"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.mobilization_date
                        ? new Date(listItem.mobilization_date)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .split(" ")
                            .join("-")
                            .toUpperCase()
                        : "-----"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.demobilization_date
                        ? new Date(listItem.demobilization_date)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .split(" ")
                            .join("-")
                            .toUpperCase()
                        : "-----"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.demobilization_comments
                        ? listItem.demobilization_comments
                        : "-----"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.idle_aging ? listItem.idle_aging : "N/A"}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {listItem.demobilization_type}
                    </td>
                    {/* <td className="px-6 py-4 whitespace-nowrap">
                     
                      <input
                        // disabled={listItem.contract_type === "IMMEDIATE"}
                        type="checkbox"
                        checked={checkedItems[listItem.candidate_id] || false}
                        onChange={(event) =>
                          handleCheckboxChange(
                            event,
                            listItem.candidate_id,
                            listItem
                          )
                        }
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                    
                      <input
                        type="checkbox"
                        checked={checked[listItem.candidate_id] || false}
                        onChange={(event) =>
                          handleCheckbox(event, listItem.candidate_id, listItem)
                        }
                      />
                    </td> */}
                    <td className="px-6 py-4 whitespace-nowrap relative">
                      <input
                        // disabled={listItem.contract_type === "IMMEDIATE"}
                        type="checkbox"
                        checked={
                          checkedItems.candidate_id === listItem.candidate_id
                        }
                        onChange={(event) =>
                          handleCheckboxChange(
                            event,
                            listItem.candidate_id,
                            listItem,
                            "global"
                          )
                        }
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="checkbox"
                        // checked={checked[listItem.candidate_id] || false}
                        checked={
                          checked.length > 0 &&
                          checked?.some(
                            (item) =>
                              item.candidate_id === listItem.candidate_id
                          )
                        }
                        onChange={(event) =>
                          handleCheckboxChange(
                            event,
                            listItem.candidate_id,
                            listItem,
                            "local"
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <Pagination />
      </div>
      {popUp ? (
        <RemobilizationFormPopUp
          PopUp={popUp}
          setPopUp={setPopUp}
          listData={checkedItems}
          project_id={selectedData}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
      {IdlePopUp ? (
        <Idle_PopUp
          IdlePopUp={IdlePopUp}
          setIdlePopUp={setIdlePopUp}
          listData={checked}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
